import { Routes, Route } from 'react-router-dom';

import { AuthProvider } from '@/auth/AuthContext';
import { RequireAuth } from '@/auth/RequireAuth';
import { Login } from '@/pages/Login';
import { AppShell } from '@/components/layout/AppShell';

/**
 * Top-level routing. AuthProvider runs a silent refresh on mount; RequireAuth
 * holds back the app shell until that resolves, redirecting anon users to login.
 */
export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <RequireAuth>
              <AppShell />
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}
